module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-7fc2215640ecdd8df2cc0e6811f79c51.png";